<div>
  <input (change)="fileChange($event)" type="file" [multiple]="false" [accept]="extensions">
  <div class="flex text-xs text-slate-600 mt-2">
    File types allowed:
    {{extensions}}
  </div>
</div>
